import { z } from 'zod';
import { courtSchema } from './ICourt';

export const parcelSchema = z.object({
  Parcel: z.string(),
  RealEstate_idRealEstate: z.number(),
  idRealEstateParcel: z.number().optional(),
});

export type IRealEstateParcel = z.infer<typeof parcelSchema>;

export const landParcelSchema = z.object({
  LandParcel: z.string(),
  RealEstate_idRealEstate: z.number(),
  idRealEstateLandParcel: z.number().optional(),
});

export type IRealEstateLandParcel = z.infer<typeof landParcelSchema>;

export const landParcelEntrySchema = z.object({
  idRealEstateLandRegisterEntry: z.number(),
  idCourt: z.number().nullable(),
  Court: courtSchema.nullable().optional(),
  idAdministrativeUnit: z.number().nullable(),
  LandRegister: z.string(),
  SheetLandRegister: z.string(),
  Parcel: z.string(),
  LandParcel: z.string(),
});

export const realEstateSchema = z.object({
  idRealEstate: z.number(),
  Street: z.string().nullable(),
  StreetNr: z.string().nullable(),
  StreetAdditional: z.string().nullable(),
  idPostcode: z.number().nullable(),
  Latitude: z.number().nullable(),
  Longitude: z.number().nullable(),

  /** Stattdessen ein Array aller Grundbuch‐Einträge */
  LandParcelEntryArray: z.array(landParcelEntrySchema),

  idPropertyType: z.number(),
  isBuild: z.boolean(),
  hasApartment: z.boolean(),
  BuildWith: z.string().nullable(),
  Price: z.number(),
  PriceInventoryOption: z.number().nullable(),
  Manager_idPerson: z.number().nullable(),
  hasPartialArea: z.boolean(),
  isMeasured: z.boolean(),
  hasEasement: z.boolean(),
  PaymentMeasurement_idPurchaseContractRelationType: z.number().nullable(),
  OrderMeasurement_idPurchaseContractRelationType: z.number().nullable(),
  Area: z.number().nullable(),
  EasementText: z.string().nullable(),
  idRealEstateUseType: z.number(),
  Defect: z.string().nullable(),
  Particularities: z.string().nullable(),
  idPurchaseContract: z.number(),
  Postcode: z.string().optional(),
  City: z.string().optional(),
});

export type IRealEstate = z.infer<typeof realEstateSchema>;
export type ILandParcelEntry = z.infer<typeof landParcelEntrySchema>;
